import { render, staticRenderFns } from "./CompetitionEdit.vue?vue&type=template&id=06e50b3e&"
import script from "./CompetitionEdit.vue?vue&type=script&lang=js&"
export * from "./CompetitionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports